const tabsCustomSelect = document.querySelector(".js-tabs-custom-select-init");

if (window.mobileMedia && tabsCustomSelect) {
    window.addEventListener("load", () => initMobileTabSelect(tabsCustomSelect));
}

function initMobileTabSelect(target) {
    const tabsList = target.querySelector(".js-tabs-select-items");

    if (tabsList) {
        const button = document.createElement("button");

        button.type = "button";
        button.textContent = tabsList.querySelector(".active").textContent;
        button.className = "tabs-mobile-select__button";

        target.prepend(button);

        button.addEventListener("click", () => {
            tabsList.classList.toggle("active");
            button.classList.toggle("active");
        });

        Array.from(tabsList.children).forEach((item) => {
            item.addEventListener("click", () => {
                button.textContent = item.textContent;
                button.classList.remove("active");
                tabsList.classList.remove("active");
            });
        });

        document.addEventListener("click", (e) => {
            if (tabsList.classList.contains("active") && !target.contains(e.target)) {
                tabsList.classList.remove("active");
                button.classList.remove("active");
            }
        });
    }
}
